import { render } from "./project_permission.vue?vue&type=template&id=118e45c2&scoped=true"
import script from "./project_permission.js?vue&type=script&lang=js"
export * from "./project_permission.js?vue&type=script&lang=js"

import "./project_permission.vue?vue&type=style&index=0&id=118e45c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118e45c2"]])

export default __exports__